export const colors = {
  fg: 0x0,
  bg: 0xe2e2e2,
  cursor: 0x6f87f1,
  cursorAlpha: 0.26,
  yellow: 0xFFBF00,
  green: 0x469f6a,
  blue: 0x6f87f1,
  red: 0xd8465c,
  gray: 0x939393,

  beatNumberFillQuestion: '#6f87f1',
  beatNumberFillCorrect: '#469f6a',
  //beatNumberFillMiss: "#D8465C",
  //beatNumberFillOffTime: "#b0bb41",
  textFg: '#000000',

  chevronColorFilled: 0x437e54,

  promptBgQuestion: 0x9faff6,
  promptBgCorrect: 0x00a165,
  promptFgCorrect: 0xe2e2e2,
  promptFgQuestion: 0x0,
  promptBgWrong: 0xc3374d,
  promptFgWrong: 0xe2e2e2,

  //progressFillMiss: 0xf53900,
  //progressBorderMiss: 0xbca59e,
  //progressFillOnTime: 0x00a165,
  //progressBorderOnTime: 0x9caaa2,
  //progressFillOffTime: 0xd3b506,
  //progressBorderOffTime: 0xa7a896,
  progressAlphaFill: 0.19,
  progressAlphaStroke: 1,

  //noteFillOnTime: 0x3d945e,
  //noteFillOffTime: 0xb0bb41,
  //noteFillMiss: 0xd8465c,

  whiteKey: 0xffffff,
  blackKey: 0x000000,
  keyTintActionRequired: 0x9faff6,
  keyTintPressedWrong: 0xd8465c,
  //keyTintPressed: 0x35bc5b,
  keyTintPressed: 0x6db970,
  keyLabelCorrect: '#00a165',
};

export function hex(num: number) {
  return '#' + num.toString(16);
}
